// require('antd/dist/antd.css');
import '@alife/next/dist/next.css';
import '../css/index.less';
import '../css/mixins.less';


import dva from 'dva';
import models from './models/Finance';

// import models from './models';
import 'dbl-fetch-polyfill';

// 1. Initialize
const app = dva();

// 2. Plugins
// app.use({});

// 3. Model
models.forEach((m) => {
  app.model(m);
});
// 4. Router
app.router(require('./router/finance'));

// 5. Start
app.start('#finance');




// WEBPACK FOOTER //
// ./src/scripts/finance.js